
	import { Component, Vue } from 'vue-property-decorator';
	import { serverProps } from '@/Common/Environment/const';

	@Component({})
	export default class Impersonated extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected get isAnonymousContext(): boolean {
			return this.state.isAnonymousContext;
		}

		protected get breadcrumbs(): APS.IBreadcrumbs {
			return this.state.breadcrumbs;
		}

		protected get error404(): APS.IError404 {
			return this.state.error404;
		}
	}
